
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="block mb-6">
              <span className="font-display font-bold text-2xl tracking-wider text-white">
                QUIK<span className="text-brand-neonBlue">PIX</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              New Zealand's premier provider of high-tech photo experiences and brand activations. Capturing moments, creating movements.
            </p>
          </div>

          <div>
            <h3 className="text-white font-display font-semibold mb-4">Products</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/product/360-video" className="hover:text-brand-neonBlue cursor-pointer">360x Video Booth</Link></li>
              <li><Link to="/product/brandpix" className="hover:text-brand-neonBlue cursor-pointer">BrandPix AI</Link></li>
              <li><Link to="/product/photostation" className="hover:text-brand-neonBlue cursor-pointer">PhotoStation</Link></li>
              <li><Link to="/product/roam" className="hover:text-brand-neonBlue cursor-pointer">Pro Roam</Link></li>
              <li><Link to="/product/mosaix" className="hover:text-brand-neonBlue cursor-pointer">Mosaix</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-display font-semibold mb-4">Locations</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/location/auckland" className="hover:text-brand-neonBlue">Auckland</Link></li>
              <li><Link to="/location/wellington" className="hover:text-brand-neonBlue">Wellington</Link></li>
              <li><Link to="/location/christchurch" className="hover:text-brand-neonBlue">Christchurch</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-display font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="text-slate-400 hover:text-brand-neonPink transition-colors"><Instagram size={20} /></a>
              <a href="#" className="text-slate-400 hover:text-brand-neonBlue transition-colors"><Facebook size={20} /></a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><Linkedin size={20} /></a>
            </div>
            <div className="flex items-center gap-2 text-slate-400 text-sm">
              <Mail size={16} />
              <span>hello@quikpix.co.nz</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>© {new Date().getFullYear()} QuikPix NZ. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/partners" className="hover:text-white cursor-pointer">Agency Partner Program</Link>
            <Link to="/staff" className="hover:text-white cursor-pointer">Staff Login</Link>
            <Link to="/login" className="hover:text-white cursor-pointer">Licensee Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
